import { render, staticRenderFns } from "./PalletStructureManual.vue?vue&type=template&id=1b2ee30a&"
import script from "./PalletStructureManual.vue?vue&type=script&lang=js&"
export * from "./PalletStructureManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports